<template>
  <v-container fluid>
    <v-layout column>
      <v-flex xs12>
        <v-text-field
          append-icon="mdi-window-close"
          class="mx-5 mt-5"
          flat
          hide-details
          label="Cerca..."
          prepend-inner-icon="mdi-magnify"
          solo-inverted
          v-model="search"
          @click:append="search = ''"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-card
          elevation="0"
          class="transparent"
        >
          <v-card-text class="pa-5">
            <v-layout row>
              <v-flex
                xs12
                sm6
                md4
                lg3
                :key="index"
                v-for="(m, index) in displayMedia"
              >
                <v-card class="ma-4">
                  <v-img
                    class="white--text"
                    height="200px"
                    :src="m.src"
                  >
                  </v-img>

                  <v-card-title
                    class="preview-title"
                    v-if="media[index].edit == false"
                  >{{m.alt}}</v-card-title>

                  <v-card-title
                    class="preview-title"
                    v-else
                  >
                    <v-text-field
                      v-model="m.alt"
                      label="Testo alternativo"
                    ></v-text-field>
                  </v-card-title>

                  <v-card-text
                    class="preview-text"
                    v-if="media[index].edit == false"
                  >{{m.name}}</v-card-text>

                  <v-card-text
                    class="preview-text"
                    v-else
                  >
                    <v-text-field
                      v-model="m.name"
                      label="Nome del file"
                    ></v-text-field>
                  </v-card-text>

                  <v-card-actions class="buttons">
                    <v-btn
                      small
                      dark
                      color="primary"
                      class="ma-1"
                      @click="copyUrl(m.name)"
                    >
                      <v-icon>mdi-clipboard-text</v-icon>
                    </v-btn>

                    <v-btn
                      small
                      dark
                      color="orange"
                      class="ma-1"
                      v-if="media[index].edit == false"
                      @click="toggleEdit(index)"
                    >
                      <v-icon>mdi-pen</v-icon>
                    </v-btn>

                    <v-btn
                      small
                      dark
                      color="orange"
                      class="ma-1"
                      v-else
                      @click="editMedia(m)"
                    >
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>

                    <v-btn
                      small
                      dark
                      color="red"
                      class="ma-1"
                      @click="showDeleteDialog(m)"
                    >
                      <v-icon>mdi-delete-empty</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="text-center">
            <v-pagination
              v-model="page"
              :length="pages"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Snackbar -->
    <v-snackbar
      right
      multi-line
      :color="snackbarColor"
      v-model="snackbar"
    >
      <b>
        <span v-if="errors">{{snackbarText}}</span>
        <span v-else>{{snackbarText}}</span>
      </b>
      <v-btn
        text
        @click="snackbar = false"
      >
        Chiudi
      </v-btn>
    </v-snackbar><!-- /Snackbar -->

    <!-- Dialog -->
    <v-layout justify-center>
      <v-dialog
        v-model="dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="headline primary--text">Eliminare media?</v-card-title>

          <v-card-text>
            Scegliendo di proseguire, il file ed ogni informazione relativa ad esso salvata nel database verranno eliminati.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              text
              @click="dialog = false"
            >
              Indietro
            </v-btn>

            <v-btn
              color="red"
              text
              @click="deleteMedia"
            >
              Prosegui
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout><!-- /Dialog-->
  </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        page: 1,
        perPage: 8,
        pages: null,
        displayMedia: null,
        selectedMedia: null,
        errors: false,
        dialog: false,
        snackbar: false,
        snackbarText: null,
        search: ''
      }
    },
    methods: {
      async copyUrl(name) {
        try {
          await navigator.clipboard.writeText(`${process.env.VUE_APP_API}/img/${name}`);
          this.errors = false
          this.snackbarText = 'URL copiato nella clipboard!'
        } catch (err) {
          this.errors = true
          this.snackbarText = 'Copia URL fallita...'
        }

        this.snackbar = true
      },
      toggleEdit(index) {
        this.media[index].edit = true
      },
      editMedia(media) {
        this.media.map(el => {
          if (el.id === media.id) {
            el.edit = false
          }
        })

        this.$store.dispatch('editMedia', media)
          .then(res => {
            if (res.status === 200) {
              this.errors = false
              this.snackbarText = 'Media modificato con successo!'
              this.$store.dispatch('fetchMedia')
            } else {
              this.errors = true
              this.snackbarText = 'Errore nella modifica del media...'
            }

            this.snackbar = true
          })
      },
      showDeleteDialog(selected) {
        this.selectedMedia = selected
        this.dialog = true
      },
      deleteMedia() {
        this.dialog = false

        this.$store.dispatch('deleteMedia', this.selectedMedia)
          .then(res => {
            if (res.status === 200) {
              this.errors = false
              this.snackbarText = 'Media eliminato con successo!'
              this.$store.dispatch('fetchMedia')
            } else {
              this.errors = true
              this.snackbarText = 'Errore nell\'eliminazione del media...'
            }

            this.snackbar = true
          })
      },
      paginate(list) {
        const start = (this.perPage * this.page) - this.perPage
        const end = (this.perPage * this.page) - 1

        return list.filter((el, index) => {
          if (index >= start && index <= end) {
            return el
          }
        })
      },
      filterSearch(val) {
        val = val.toLowerCase()

        return this.media.filter((element, index) => {
          if (element.name.toLowerCase().indexOf(val) >= 0 || element.alt.toLowerCase().indexOf(val) >= 0) {
            return element
          }
        })
      }
    },
    computed: {
      media() {
        return this.$store.getters.media
      },
      snackbarColor() {
        return this.errors ? 'pink' : 'primary'
      }
    },
    watch: {
      media(val) {
        this.displayMedia = this.paginate(val)
        this.pages = Math.ceil(val.length / this.perPage)
      },
      page() {
        const filtered = this.filterSearch(this.search)
        this.displayMedia = this.paginate(filtered)
        this.pages = Math.ceil(filtered.length / this.perPage)
      },
      search(val) {
        this.page = 1
        const filtered = this.filterSearch(val)
        this.displayMedia = this.paginate(filtered)
        this.pages = Math.ceil(filtered.length / this.perPage)
      }
    },
    mounted() {
      this.$store.dispatch('fetchMedia')
    }
  }
</script>

<style scoped>
  .buttons {
    margin-left: auto;
    width: fit-content;
  }

  .preview-title {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  .preview-text {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .transparent {
    background-color: transparent;
  }
</style>
